import React, { useEffect, useState } from "react";
import { db } from "../../firebase/config";
import { 
  collection, 
  getDocs, 
  deleteDoc, 
  doc, 
  updateDoc,
  increment,
  arrayUnion
} from "firebase/firestore";
import { Button, Container, Card, Modal, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { setDoc, getDoc, query, where} from "firebase/firestore";
import { getAuth, signOut } from "firebase/auth";
import { Offcanvas } from "react-bootstrap";
import { generateUsername } from "../../utils/usernameGenerator";
import { onAuthStateChanged } from "firebase/auth";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

export default function Dashboard() {
  const [chats, setChats] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedChat, setSelectedChat] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [chatToDelete, setChatToDelete] = useState(null);
  const [myGroup, setMyGroup] = useState("");
  const [showDrawer, setShowDrawer] = useState(false);
  const [profile, setProfile] = useState(null);
  const [userName, setUserName] = useState("");
  const [showUsernameModal, setShowUsernameModal] = useState(false);
  const [username, setUsername] = useState("");
  // const [generatedUsername, setGeneratedUsername] = useState("");
  const [uploading, setUploading] = useState(false);
  const [userPhotoURL, setUserPhotoURL] = useState("")

  const fileInputRef = React.useRef(null);

  const openDrawer = () => setShowDrawer(true);
  const closeDrawer = () => setShowDrawer(false);
  const navigate = useNavigate();
  const auth = getAuth();
  const [user, setUser] = useState(null);

  useEffect(() => {
  const reloaded = sessionStorage.getItem("dashboardReloaded");

    if (!reloaded) {
      sessionStorage.setItem("dashboardReloaded", "true");
      window.location.reload();
    }
  }, []);


  useEffect(() => {
    if (!user) return;
    const fetchChats = async () => {
      const snapshot = await getDocs(collection(db, "conversations"));

      const chatsData = [];

      for (const d of snapshot.docs) {
        const chat = { id: d.id, ...d.data() };

        const readDoc = await getDoc(
          doc(db, "userReads", `${user.uid}_${chat.id}`)
        );

        const lastRead = readDoc.exists()
          ? readDoc.data().lastReadMessageId
          : null;

        chat.hasUnread =
          chat.lastMessageId && chat.lastMessageId !== lastRead;

        chatsData.push(chat);
      }

      setChats(chatsData);
    };
    fetchChats();
  }, [user]);


  useEffect(() => {

  const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {

    if (!firebaseUser) return;

    setUser(firebaseUser); // ✅ important

    const userDoc = await getDoc(doc(db, "users", firebaseUser.uid));

    if (!userDoc.exists()) return;

    const data = userDoc.data();
    setUserName(data.username);
    setUserPhotoURL(data.photoURL)

    if (data.changedUsername === false) {
      const suggestion = generateUsername(firebaseUser.displayName);

      // setGeneratedUsername(suggestion);
      setUsername(suggestion);
      setShowUsernameModal(true);
    }

    setProfile({
      name: data.username || firebaseUser.displayName,
      photo: data.photoURL || firebaseUser.photoURL,
      groupsJoined: data?.stats?.groupsJoined || 0,
      totalVotes: data?.stats?.totalVotesReceived || 0,
      officialMessages: data?.stats?.officialMessages || 0,
      groupsStarted: data?.stats?.groupsStarted || 0,
      groups: data?.groups || []
    });

  });

  return () => unsubscribe();

}, []);

const handleAvatarClick = () => {
    fileInputRef.current.click();
  };

  const handleSignOut = async () => {
    await signOut(auth);
    navigate("/");
  };

  const handleJoinClick = async (chat) => {
    const user = auth.currentUser;
    if (!user) return;

    const userRef = doc(
      db,
      "userConversations",
      `${user.uid}_${chat.id}`
    );

    const existing = await getDoc(userRef);

    // ✅ If user already joined → skip modal
    if (existing.exists()) {
      const savedGroup = existing.data().group;

      navigate(`/chat/${chat.id}?group=${savedGroup}`);
      return;
    }

    // ❌ Otherwise show modal
    setSelectedChat(chat);
    setMyGroup("");
    setShowModal(true);
  };

  const handleDeleteClick = (chat, e) => {
    e.stopPropagation(); // prevent join
    setChatToDelete(chat);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    if (!chatToDelete) return;

    const user = auth.currentUser;

    if (chatToDelete.creatorId !== user.uid) {
      alert("Only the creator can delete this conversation.");
      setShowDeleteModal(false);
      return;
    }

    try {
      const chatId = chatToDelete.id;

      // 🔥 Delete messages subcollection
      const messagesSnapshot = await getDocs(
        collection(db, "conversations", chatId, "messages")
      );

      const deletePromises = messagesSnapshot.docs.map((msg) =>
        deleteDoc(doc(db, "conversations", chatId, "messages", msg.id))
      );

      await Promise.all(deletePromises);

      // 🔥 Delete conversation doc
      await deleteDoc(doc(db, "conversations", chatId));
      // reduce groupsStarted count for creator
       await setDoc(
            doc(db, "users", user.uid),
            {
              stats: {
                groupsStarted: increment(-1),
                groupsJoined: increment(-1)
                // TODO: reduce number of likes and influence received on this group.
              }
            },
            { merge: true }
          );

      // Update UI
      setChats((prev) => prev.filter((c) => c.id !== chatId));

      setShowDeleteModal(false);
      setChatToDelete(null);

    } catch (error) {
      console.error("Delete failed:", error);
    }
  };


  const handleJoin = async () => {
    const user = auth.currentUser;
    if (!user) return;

    const userConversationRef = doc(
      db,
      "userConversations",
      `${user.uid}_${selectedChat.id}`
    );

    const existing = await getDoc(userConversationRef);

    // If already joined this conversation
    if (existing.exists()) {
      const savedGroup = existing.data().group;

      if (savedGroup !== myGroup && savedGroup !== "") {
        alert("You have already joined the opposite group in this chat.");
        return;
      }

      navigate(`/chat/${selectedChat.id}?group=${savedGroup}`);
      setShowModal(false);
      return;
    }

    // Save membership
    await setDoc(userConversationRef, {
      userId: user.uid,
      conversationId: selectedChat.id,
      group: myGroup,
      joinedAt: new Date()
    });

    // Update conversation counts
    const convoRef = doc(db, "conversations", selectedChat.id);

    if (myGroup === "A") {
      await updateDoc(convoRef, {
        "groupA.count": increment(1)
      });
    }

    if (myGroup === "B") {
      await updateDoc(convoRef, {
        "groupB.count": increment(1)
      });
    }

    // 🔥 Update user profile
    const userRef = doc(db, "users", user.uid);
    const userDoc = await getDoc(userRef);

    const groupName =
      myGroup === "A"
        ? selectedChat.groupA.name
        : myGroup === "B"
        ? selectedChat.groupB.name
        : null;

    if (groupName) {

      if (!userDoc.exists()) {
        // create profile
        await setDoc(userRef, {
          username: user.displayName,
          photoURL: user.photoURL,
          groups: [{
            conversationId: selectedChat.id,
            groupName
          }],
          stats: {
            groupsJoined: 1,
            totalVotesReceived: 0,
            officialMessages: 0
          }
        });
      } else {

        const data = userDoc.data();
        const existingGroups = data.groups || [];

        const alreadyJoined = existingGroups.some(
          g => g.conversationId === selectedChat.id
        );

        if (!alreadyJoined) {
          await updateDoc(userRef, {
            groups: arrayUnion({
              conversationId: selectedChat.id,
              groupName
            }),
            "stats.groupsJoined": increment(1)
          });
        }
      }
    }

    navigate(`/chat/${selectedChat.id}?group=${myGroup}`);
    setShowModal(false);
  };

  const saveUsername = async () => {
    if (!username.trim()) return;

    if (username.trim().length < 3) {
      alert("Username must be at least 3 characters");
      return;
    }

    const userRef = doc(db, "users", user.uid);

    await updateDoc(userRef, {
      username: username.trim(),
      changedUsername: true
    });

    setUserName(username.trim());
    setShowUsernameModal(false);
  };

  const handlePhotoChange = async (e) => {
    const file = e.target.files[0];
    if (!file || !user) return;

    try {
      setUploading(true);

      const storage = getStorage();
      const storageRef = ref(storage, `profilePhotos/${user.uid}`);

      await uploadBytes(storageRef, file);

      const downloadURL = await getDownloadURL(storageRef);

      // update firestore
      await updateDoc(doc(db, "users", user.uid), {
        photoURL: downloadURL
      });

      // update UI immediately
      setProfile(prev => ({
        ...prev,
        photo: downloadURL
      }));

    } catch (err) {
      console.error(err);
      alert("Upload failed");
    }

    setUploading(false);
  };

  return (
    <Container fluid className="vh-100 d-flex flex-column"
      style={{
  background: "linear-gradient(180deg,#f8faf9 0%,#eef3ef 100%)",
  padding: "20px",
}}>

      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handlePhotoChange}
      />
      
      {/* Header */}
      <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        paddingBottom: "16px",
        marginBottom: "20px",
        borderBottom: "1px solid rgba(0,0,0,0.05)"
      }}
    >

      {/* Brand */}
      <h2
        style={{
          color: "#727371",
          fontStyle: "italic",
          fontWeight: 800,
          fontSize: "20px",
          margin: 0,
        }}
      >
        GroupYarn
      </h2>

      {/* Hamburger */}
      <Button
        variant="light"
        onClick={openDrawer}
        className="rounded-circle"
        style={{
          width: "40px",
          height: "40px",
          fontSize: "18px",
          padding: 0
        }}
      >
        ☰
      </Button>

    </div>

    {profile && (
    <Card
      className="mb-4 border-0"
      style={{
        borderRadius: "20px",
        background: "white",
        boxShadow: "0 10px 25px rgba(0,0,0,0.06)",
        padding: "22px"
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "16px",
          flexWrap: "wrap"
        }}
      >

        {/* Avatar */}
        {profile.photo ? (
          <img
            title="Click to change photo"
            src={profile.photo}
            alt="profile"
            onClick={handleAvatarClick}
            style={{
              width: "44px",
              height: "44px",
              borderRadius: "50%",
              objectFit: "cover"
            }}
          />
        ) : (
          <div
            title="Click to change photo"
            onClick={handleAvatarClick}
            style={{
              width: "44px",
              height: "44px",
              borderRadius: "50%",
              background: "#1e293b",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontSize: "22px",
              fontWeight: 600
            }}
          >
            {profile.name?.charAt(0)?.toUpperCase()}
          </div>
        )}

        {/* Username */}
        <div>
          <div style={{ fontWeight: 700, fontSize: "15px", color: "#939394" }}>
            @{profile.name.replace(/\s+/g, "")}
          </div>

          {/* <div style={{ fontSize: "13px", color: "#6b7280" }}>
            Your public reputation
          </div> */}
        </div>
      </div>

      {/* Stats */}
      <div
        style={{
          display: "flex",
          gap: "12px",
          marginTop: "20px",
          flexWrap: "wrap"
        }}
      >
        <div
          style={{
            flex: 1,
            minWidth: "70px",
            background: "#f8fafc",
            padding: "12px",
            borderRadius: "12px",
            textAlign: "center"
          }}
        >
          <div style={{ fontWeight: 700, fontSize: "18px" }}>
            {profile.groupsStarted}
          </div>
          <div style={{ fontSize: "12px", color: "#6b7280" }}>
            Created
          </div>
        </div>

        <div
          style={{
            flex: 1,
            minWidth: "70px",
            background: "#f8fafc",
            padding: "12px",
            borderRadius: "12px",
            textAlign: "center"
          }}
        >
          <div style={{ fontWeight: 700, fontSize: "18px" }}>
            {profile.totalVotes}
          </div>
          <div style={{ fontSize: "12px", color: "#6b7280" }}>
            Likes
          </div>
        </div>

        <div
          style={{
            flex: 1,
            minWidth: "70px",
            background: "#f8fafc",
            padding: "12px",
            borderRadius: "12px",
            textAlign: "center"
          }}
        >
          <div style={{ fontWeight: 700, fontSize: "18px" }}>
            {profile.officialMessages}
          </div>
          <div style={{ fontSize: "12px", color: "#6b7280" }}>
            Influence
          </div>
        </div>
      </div>

      {/* Groups */}
      {profile.groups?.length > 0 && (
        <div style={{ marginTop: "16px" }}>
          
        </div>
      )}
    </Card>
  )}

      {/* Scrollable Chat List */}
      <div
        className="flex-grow-1 overflow-auto pe-2"
        style={{ maxHeight: "85vh" }}
      >
        {chats.length === 0 && (
          <div
            style={{
              textAlign: "center",
              marginTop: "80px",
              color: "#777"
            }}
          >
            <div style={{ fontSize: "40px", marginBottom: "10px" }}>💬</div>

            <h5 style={{ fontWeight: 600 }}>No conversations yet</h5>

            <p style={{ fontSize: "14px" }}>
              Start a discussion between two groups.
            </p>

            <Button
              onClick={() => navigate("/create-chat")}
              className="rounded-pill"
              style={{
                background: "linear-gradient(135deg,#2d512f,#318333)",
                border: "none"
              }}
            >
              Create Conversation
            </Button>
          </div>
                  )}

        {chats.map(chat => {
          const truncate = (text, max = 25) =>
            text?.length > max ? text.slice(0, max) + "..." : text || "";

          const groupAPreview = truncate(chat.groupA?.name);
          const groupBPreview = truncate(chat.groupB?.name);

          return (
          <Card
  key={chat.id}
  className="mb-3 border-0"
  style={{
    borderRadius: "22px",
    cursor: "pointer",
    background: "rgba(255,255,255,0.9)",
    backdropFilter: "blur(10px)",
    boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
    transition: "all .25s ease",
    position: "relative",
    overflow: "hidden"
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.transform = "translateY(-3px)";
    e.currentTarget.style.boxShadow = "0 14px 30px rgba(0,0,0,0.12)";
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.transform = "translateY(0)";
    e.currentTarget.style.boxShadow = "0 6px 18px rgba(0,0,0,0.06)";
  }}
  onClick={() => handleJoinClick(chat)}
>
  <Card.Body style={{ padding: "16px 16px 14px 16px" }}>

    {/* DELETE BUTTON */}
    {user && chat.creatorId === user.uid && (
      <div
        onClick={(e) => handleDeleteClick(chat, e)}
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          width: "28px",
          height: "28px",
          borderRadius: "8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#999",
          transition: "all .2s"
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = "#f3f4f6";
          e.currentTarget.style.color = "#dc2626";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = "transparent";
          e.currentTarget.style.color = "#999";
        }}
      >
        ✕
      </div>
    )}

    {/* 🔥 TOPIC (HERO) */}
    <div
      style={{
        fontSize: "13px",
        fontWeight: "600",
        color: "#111827",
        lineHeight: "1.4",
        marginBottom: "10px"
      }}
    >
      {chat.topic || "Untitled conversation"}
    </div>

    {/* GROUP ROW */}
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between"
      }}
    >

      {/* LEFT SIDE */}
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>

        {/* AVATARS */}
        <div style={{ position: "relative", width: "48px", height: "34px" }}>
          
          <div
            style={{
              width: "32px",
              height: "32px",
              borderRadius: "50%",
              background: "linear-gradient(135deg,#557e56,#7ca97d)",
              position: "absolute",
              left: 0,
              border: "2px solid white",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontWeight: "600",
              fontSize: "13px"
            }}
          >
            {chat.groupA.name?.charAt(0)}
          </div>

          <div
            style={{
              width: "32px",
              height: "32px",
              borderRadius: "50%",
              background: "linear-gradient(135deg,#1e521a,#4d8f45)",
              position: "absolute",
              left: "18px",
              border: "2px solid white",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontWeight: "600",
              fontSize: "13px"
            }}
          >
            {chat.groupB.name?.charAt(0)}
          </div>
        </div>

        {/* GROUP TEXT */}
        <div>
          <div
            style={{
              fontSize: "13px",
              color: "#6b7280",
              fontWeight: "500",
              marginLeft: "12px"
            }}
          >
            {chat.groupA.name} <span style={{ opacity: 0.6 }}>vs</span> {chat.groupB.name}
          </div>

          <div
            style={{
              fontSize: "12px",
              color: "#9ca3af",
              marginTop:"2px",
            }}
          >
            {chat.lastMessage
              ? chat.lastMessage.slice(0, 35) + "..."
              : "No messages yet"}
          </div>
        </div>
      </div>

      {/* RIGHT SIDE */}
      <div style={{ textAlign: "right" }}>
        <div
          style={{
            fontSize: "11px",
            color: "#9ca3af",
            marginBottom: "4px"
          }}
        >
          {chat.lastMessageAt?.seconds
            ? new Date(chat.lastMessageAt.seconds * 1000)
                .toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit"
                })
            : ""}
        </div>

        {/* UNREAD DOT */}
        {chat.hasUnread && (
          <div
            style={{
              width: "8px",
              height: "8px",
              background: "#22c55e",
              borderRadius: "50%",
              marginLeft: "auto"
            }}
          />
        )}
      </div>
    </div>
  </Card.Body>
</Card>
          );
        })}
      </div>

     {/* Join Modal */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
      >
        <Modal.Body className="p-4">

          {/* Icon */}
          {/* <div
            style={{
              width: "64px",
              height: "64px",
              borderRadius: "50%",
              background: "linear-gradient(135deg, #0d6efd, #6f42c1)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 18px",
              color: "white",
              fontSize: "28px",
              fontWeight: "bold",
            }}
          >
            ?
          </div> */}

          {/* Title */}
          <h5 style={{ color: "#043b07" }} className="text-center fw-bold mb-2">
            Choose Your Group
          </h5>

          {/* Description */}
          <p
            className="text-center"
            style={{ fontSize: "14px", color: "#710e0e", lineHeight: "1.5" }}
          >
            All selected groups will be visible on your public profile page.
          </p>

          {/* Divider */}
          <div
            style={{
              height: "1px",
              background: "rgba(0,0,0,0.05)",
              margin: "18px 0",
            }}
          />

          {/* Options */}
          <Form>
            <div className="d-grid gap-2">

              <Form.Check
                type="radio"
                name="group"
                id="groupA"
                value="A"
                onChange={(e) => setMyGroup(e.target.value)}
                label={
                  <span style={{ fontWeight: 500 }}>
                    {selectedChat?.groupA.name}
                  </span>
                }
                className="p-2 rounded-3"
              />

              <Form.Check
                type="radio"
                name="group"
                id="groupB"
                value="B"
                onChange={(e) => setMyGroup(e.target.value)}
                label={
                  <span style={{ fontWeight: 500 }}>
                    {selectedChat?.groupB.name}
                  </span>
                }
                className="p-2 rounded-3"
              />

              <Form.Check
                type="radio"
                name="group"
                id="watchOnly"
                value=""
                onChange={() => setMyGroup("")}
                label={
                  <span style={{ fontWeight: 500 }}>
                    Watch Only
                    <span style={{ fontSize: "12px", color: "#888", marginLeft: "6px" }}>
                      (No visible identity)
                    </span>
                  </span>
                }
                className="p-2 rounded-3"
              />

            </div>
          </Form>

          {/* Button */}
          <div className="d-grid mt-4">
            <Button
              style={{ background: "linear-gradient(135deg, #2d512f, #318333)", border: "none" }}
              onClick={handleJoin}
              disabled={myGroup === null}
              className="rounded-pill py-2"
            >
              Enter Chat
            </Button>
          </div>

        </Modal.Body>
      </Modal>


      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
      >
        <Modal.Body className="text-center p-4">
          {/* <div
            style={{
              width: "60px",
              height: "60px",
              borderRadius: "50%",
              background: "#ffe5e5",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 20px",
              fontSize: "28px",
              color: "#dc3545"
            }}
          >
            ×
          </div> */}

          <h5 className="fw-bold mb-2">Delete Conversation?</h5>

          <p style={{ color: "#777", fontSize: "14px" }}>
            This will permanently remove this chat and all its messages.
            This action cannot be undone.
          </p>

          <div className="d-flex justify-content-center gap-3 mt-4">
            <Button
              variant="light"
              onClick={() => setShowDeleteModal(false)}
              className="rounded-pill px-4"
            >
              Cancel
            </Button>

            <Button
              style={{ background: "linear-gradient(135deg, #dc3545, #5d030c)", border: "none" }}
              // variant="success"
              onClick={confirmDelete}
              className="rounded-pill px-4"
            >
              Delete
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      
      {/* Username Modal */}
      <Modal
        show={showUsernameModal}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Body className="p-4 text-center">

          <h5 className="fw-bold mb-2">Change username ?</h5>

          <p style={{ fontSize: "14px", color: "#777" }}>
            We suggested a username for you. You can also edit it.
          </p>

          <Form className="mt-3">
            <Form.Control
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="rounded-pill text-center"
            />
          </Form>

          <div className="d-grid mt-4">
            <Button
              onClick={saveUsername}
              style={{
                background: "linear-gradient(135deg,#2d512f,#318333)",
                border: "none"
              }}
              className="rounded-pill"
            >
              Continue
            </Button>
          </div>

        </Modal.Body>
      </Modal>

      <Offcanvas
        show={showDrawer}
        onHide={closeDrawer}
        placement="end"
      >

        <Offcanvas.Header closeButton>
          <Offcanvas.Title
            style={{
              fontWeight: 700,
              color: "#0a4601"
            }}
          >
            GroupYarn
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>

          {user && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                marginBottom: "25px"
              }}
            >
              <img
                onClick={handleAvatarClick}
                src={userPhotoURL}
                alt="avatar"
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  objectFit: "cover"
                }}
              />

              <div>
                <div style={{ fontWeight: 600 }}>
                  @{userName.replace(/\s+/g, "")}
                </div>

                {/* <div style={{ fontSize: "12px", color: "#777" }}>
                  {user.email}
                </div> */}
              </div>
            </div>
          )}

          {/* New Chat */}
          <Button
            onClick={() => {
              closeDrawer();
              navigate("/create-chat");
            }}
            className="w-100 mb-3 rounded-pill"
            style={{
              background: "linear-gradient(135deg,#2d512f,#318333)",
              border: "none"
            }}
          >
            + Create Chat
          </Button>

          {/* Sign out */}
          <Button
            variant="light"
            onClick={handleSignOut}
            className="w-100 rounded-pill"
          >
            Sign out
          </Button>

        </Offcanvas.Body>

      </Offcanvas>
    </Container>
  );
}